<div class="card mt-4">
    <p-breadcrumb [model]="breadcrumbItems" [home]="breadcrumbInfo"></p-breadcrumb>
</div>
<div class="card mt-4">

    <div class="mb-4">
        <div class="font-semibold text-xl">Liste des Infos & Libellés - {{this.nomDo}} - {{this.do}}</div>
        <div class="flex gap-2 justify-end">
            <p-button (onClick)="activeTab = 0" [rounded]="true" label="1" styleClass="w-2rem h-2rem p-0"
                [outlined]="activeTab !== 0" />
            <p-button (onClick)="activeTab = 1" [rounded]="true" label="2" styleClass="w-2rem h-2rem p-0"
                [outlined]="activeTab !== 1" />
        </div>
        <p-tabs [(value)]="activeTab">
            <p-tablist>
                <p-tab [value]="0"><i class="pi pi-info-circle"></i> Infos </p-tab>
                <p-tab [value]="1"><i class="pi pi-cog"></i> Libellés Infos </p-tab>
            </p-tablist>
            <p-tabpanels>
                <p-tabpanel [value]="0">
                    <p-toolbar styleClass="mb-6">
                        <ng-template #start>
                            <p-button label="Ajouter" (onClick)="openNewInfo()" icon="pi pi-plus" class="mr-2" />
                            <p-button severity="secondary" label="Supprimer" icon="pi pi-trash" outlined
                                [style]="{'color': 'var(--primary-color)'}"
                                [disabled]="!selectedInfos || !selectedInfos.length"
                                (onClick)="deleteSelectedInfos()" />
                        </ng-template>
  <ng-template #end>
            <p-button label="Importer en masse" icon="pi pi-upload" styleClass="p-button-primary" class="mr-2"
                (click)="openUploadDialog()" />
            <p-dialog header="Importation en masse" [(visible)]="UploadDialog" [breakpoints]="{ '960px': '75vw' }"
                [style]="{ width: '30vw' }" [modal]="true">

                <div class="flex flex-col items-center text-center p-4 w-full">

                    <!-- Bouton Export -->
                    <p-button label="Exporter le modèle" icon="pi pi-download" severity="secondary" class="mb-4"
                        (onClick)="telechargerTemplateCSV()">
                    </p-button>

                    <!-- Upload -->
                    <p-fileupload #uploader name="demo[]" [multiple]="true" [accept]="'.csv'" [auto]="false"
                        [customUpload]="true" (uploadHandler)="onUpload($event, uploader)" [maxFileSize]="500000"
                        mode="advanced" uploadLabel="Importer" class="w-full">

                        <!-- Texte d'info quand vide -->
                        <ng-template #empty>
                            <div class="text-sm text-gray-500">
                                Faites glisser et déposez le fichier CSV ici pour l'importer.
                            </div>
                        </ng-template>

                        <!-- Liste des fichiers sélectionnés -->
                        <ng-template #content>
                            <ul *ngIf="uploadedFiles.length" class="mt-2 text-sm">
                                <li *ngFor="let file of uploadedFiles">{{ file.name }} - {{ file.size }} bytes</li>
                            </ul>
                        </ng-template>
                    </p-fileupload>

                    <!-- Radio buttons -->
                    <div class="mt-4">
                        <label class="block font-semibold text-sm mb-2">Voulez-vous écraser les données existantes
                            ?</label>
                        <div class="flex justify-center gap-6">
                            <div class="flex items-center gap-2">
                                <p-radioButton name="ecrasement" [value]="true" [(ngModel)]="add_on"
                                    inputId="noEcrase" />
                                <label for="noEcrase" class="text-sm">Non</label>
                            </div>
                            <div class="flex items-center gap-2">
                                <p-radioButton name="ecrasement" [value]="false" [(ngModel)]="add_on"
                                    inputId="yesEcrase" />
                                <label for="yesEcrase" class="text-sm">Oui</label>
                            </div>
                        </div>
                    </div>

                </div>

                <!-- Footer -->
                <ng-template #footer>
                    <p-button label="Fermer" icon="pi pi-times" (click)="closeUploadDialog()" class="p-button-text" />
                </ng-template>
            </p-dialog>
            <!-- <p-button label="Exporter en CSV" icon="pi pi-download" severity="secondary"

                [disabled]="loading || !societes || societes.length === 0"></p-button> -->
        </ng-template>
                        <!-- <ng-template #end>
                            <p-button label="Importer en masse" icon="pi pi-upload" styleClass="p-button-primary"
                                class="mr-2" />
                            <p-button label="Exporter en CSV" icon="pi pi-upload" severity="secondary" />
                        </ng-template> -->
                    </p-toolbar>
                    <p-table #dt1 [value]="infos" [rows]="10" [rowHover]="true" [showGridlines]="true"
                        [paginator]="true" [loading]="loading" [(selection)]="selectedInfos"
                        [globalFilterFields]="getGlobalFilterFields()" responsiveLayout="scroll"
                        [tableStyle]="{ 'min-width': '75rem' }"
                        currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} infos"
                        [showCurrentPageReport]="true" [rowsPerPageOptions]="rowsPerPageOptions">

                        <ng-template #caption>
                            <div class="flex justify-between items-center flex-column sm:flex-row">
                                <button pButton label="Réinitialiser" class="p-button-outlined mb-2"
                                    icon="pi pi-filter-slash" (click)="clear(dt1)"></button>
                                <p-iconfield iconPosition="left" class="ml-auto">
                                    <p-inputicon>
                                        <i class="pi pi-search"></i>
                                    </p-inputicon>
                                    <input pInputText type="text" (input)="onGlobalFilter(dt1, $event)"
                                        placeholder="Rechercher..." />
                                </p-iconfield>
                            </div>
                        </ng-template>

                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width: 3rem">
                                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                                </th>
                                <th *ngFor="let col of cols" [ngSwitch]="col.field === 'actions'">
                                    <div *ngSwitchCase="false" class="flex justify-between items-center">
                                        <span>{{ col.header }}</span>
                                        <p-columnFilter *ngIf="col.filter" type="text" [field]="col.field"
                                            display="menu" [placeholder]="'Filtrer par ' + col.header"></p-columnFilter>
                                    </div>
                                    <div *ngSwitchCase="true" class="flex justify-center items-center">
                                        {{ col.header }}
                                    </div>
                                </th>
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-info>
                            <tr>
                                <td>
                                    <p-tableCheckbox [value]="info"></p-tableCheckbox>
                                </td>
                                <td *ngFor="let col of cols" [ngSwitch]="col.field === 'actions'">
                                    <div *ngSwitchCase="false">
                                        {{ info[col.field] }}
                                    </div>
                                    <div *ngSwitchCase="true" class="flex items-center justify-center">
                                        <!-- <p-button icon="pi pi-eye" [rounded]="true" [outlined]="true" class="mr-1" /> -->
                                        <p-button icon="pi pi-pencil" severity="danger" [rounded]="true"
                                            (onClick)="openUpdateInfo(info.code_interne)" [outlined]="true"
                                            class="mr-1" />
                                        <p-button icon="pi pi-trash" severity="danger" [rounded]="true"
                                            [outlined]="true" (onClick)="deleteByInfo(info)" />
                                    </div>
                                </td>
                            </tr>



                        </ng-template>

                            <tr>
                                <td [attr.colspan]="cols.length + 1" >
                                    <div *ngIf="allLibelleInfosAreNull()" class="mt-2 block font-bold text-red-500">
                                                Veuillez remplir les libellés infos au début.
                                    </div>
                                </td>
                            </tr>

                        <ng-template #emptymessage>
                            <tr>
                                <td [attr.colspan]="cols.length + 1">Aucune info trouvé.
                                    <div *ngIf="allLibelleInfosAreNull()" class="mt-2 block font-bold text-red-500">
                                        Veuillez remplir les libellés infos au début.
                                    </div>
                                </td>
                            </tr>
                        </ng-template>

                        <ng-template #loadingbody>
                            <tr>
                                <td [attr.colspan]="cols.length + 1">Chargement des données infos. Veuillez patienter.
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>


                    <!-- Bloc d'ajout Info -->
                    <p-dialog [(visible)]="addInfoDialog" [style]="{ width: '1000px' }" header="Ajouter Info"
                        [modal]="true">
                        <ng-template #content>
                            <div class="flex flex-col gap-6">
                                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <ng-container *ngFor="let key of displayedColumns">
                                        <div *ngIf="libellesValues[key.field] != null" class="flex flex-col gap-2">
                                            <label class="block font-bold mb-2">{{ libellesValues[key.field] }}</label>
                                            <input pInputText [(ngModel)]="newInfoValues[key.field]" />
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-template>

                        <div *ngIf="allLibelleInfosAreNull()" class="flex justify-center mt-2">
                                <div class="font-bold text-red-500">
                                    Veuillez remplir les libellés infos au début.
                                </div>
                        </div>

                        <ng-template #footer>
                            <p-button label="Annuler" icon="pi pi-times" text (click)="hideDialog()" />
                            <p-button label="Enregistrer" icon="pi pi-save" (click)="validateAndSaveInfo()" />
                        </ng-template>
                    </p-dialog>

                    <!-- Bloc de modification Info -->
                    <p-dialog [(visible)]="updateInfoDialog" [style]="{ width: '1000px' }" header="Modifier Info"
                        [modal]="true">
                        <ng-template #content>
                            <div class="flex flex-col gap-6">
                                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <ng-container *ngFor="let key of displayedColumns">
                                        <div *ngIf="libellesValues[key.field] != null" class="flex flex-col gap-2">
                                            <label class="block font-bold mb-2">{{ libellesValues[key.field] }}</label>
                                            <input pInputText [(ngModel)]="newInfoValues[key.field]" />
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-template>

                         <div *ngIf="allLibelleInfosAreNull()" class="flex justify-center mt-2">
                                <div class="font-bold text-red-500">
                                    Veuillez remplir les libellés infos au début.
                                </div>
                        </div>
                        <ng-template #footer>
                            <p-button label="Annuler" icon="pi pi-times" text (click)="hideDialog()" />
                            <p-button label="Enregistrer" icon="pi pi-save" [disabled]="isDisableButton" (onClick)="validateAndUpdateInfo()" />
                        </ng-template>
                    </p-dialog>



                </p-tabpanel>
                <p-tabpanel [value]="1">
                    <div class="grid grid-cols-1 md:grid-cols-4 gap-6 mt-8">

                        <div *ngFor="let col of displayedColumns" class="field">
                            <label [for]="col.field" class="block font-bold mb-2">
                                {{col.label}}
                            </label>
                            <input pInputText [id]="col.field" [(ngModel)]="libellesValues[col.field]"
                                class="w-full p-2 text-sm surface-100 border-1 border-200 border-round" />
                        </div>
                    </div>

                    <!-- Bouton pour afficher plus/moins de colonnes -->
                    <div class="flex justify-center mt-4">
                        <p-button [label]="showAllColumns ? 'Afficher moins' : 'Afficher plus'"
                            icon="pi pi-chevron-down" (onClick)="toggleShowAllColumns()" [outlined]="true">
                        </p-button>
                    </div>

                    <!-- Bouton pour sauvegarder -->
                    <div class="flex justify-end mt-3 gap-3">
                        <p-button label="Annuler" styleClass="p-button-secondary" (onClick)="cancelLibelleChanges()"></p-button>
                        <p-button label="Enregistrer" icon="pi pi-save" type="submit" (onClick)="updateLibelleInfos()"
                            styleClass="p-button-primary"></p-button>
                    </div>
                </p-tabpanel>

            </p-tabpanels>
        </p-tabs>
    </div>


    <p-confirmdialog [style]="{ width: '850px' }" />
    <p-toast />


</div>
